import APIController from '../core-api-controller';

export const fetchLabReviewsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/lab_reviews${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchLabReviewDetailApi = (id = '') => {
  const path = `${APIController.endpointApi}/lab_reviews/${id}`;
  return APIController.getApiCallback(path);
};

export const createLabReviewApi = (payload = {}) => {
  const path = `${APIController.endpointApi}/lab_reviews`;
  return APIController.postCallback(path, payload);
};

export const updateLabReviewApi = (id = '', payload = {}) => {
  const path = `${APIController.endpointApi}/lab_reviews/${id}`;
  return APIController.putCallback(path, payload);
};

export const newLabPanelsApi = () => {
  const path = `${APIController.endpointApi}/lab_reviews/new`;
  return APIController.getApiCallback(path);
};

export const labReviewMarkAsCompleteApi = (id = '') => {
  const path = `${APIController.endpointApi}/lab_reviews/${id}/mark_as_complete`;
  return APIController.postCallback(path);
};

export const fetchCurrentLabReviewApi = () => {
  const path = `${APIController.endpointApi}/client_user/lab_reviews/current`;
  return APIController.getApiCallback(path);
};

export const updatePatientLabReviewApi = (id = '', data = {}) => {
  const path = `${APIController.endpointApi}/client_user/lab_reviews/${id}`;
  return APIController.putCallback(path, data);
};

export const syncManuallyLabReviewApi = (id = '', data = {}) => {
  const path = `${APIController.endpointApi}/lab_reviews/${id}/sync_manually`;
  return APIController.postCallback(path, data);
};

/**
 * Sets the lab panel charge on a lab review, or takes it off.
 *
 * `panel_charge_id` present sets that charge; sending no id at all is what
 * removes the one already there, so the payload is built by the caller rather
 * than defaulted to an empty value here.
 */
export const setLabReviewPanelChargeApi = (id = '', payload = {}) => {
  const path = `${APIController.endpointApi}/lab_reviews/${id}/set_panel_charge`;
  return APIController.postCallback(path, payload);
};

export const detachAttachmentsApi = (id = '', data = {}) => {
  const path = `${APIController.endpointApi}/lab_reviews/${id}/detach_manually`;
  return APIController.postCallback(path, data);
};
